module.exports = __webpack_public_path__ + "img/BOWTIE 3 BW.c06ae6d.svg";